import { DailyBillingSettingAPI } from "../api";
import { AccountingProduct } from "../classes"
import i18n from '@/plugins/vue-i18n';

export class DailyBillingSetting {
  constructor(data) {
    for (const [key, value] of Object.entries(data)) {
      this[key] = value;
    }
    this.typeString = i18n.t(`billing_setting.type.${data.type}`) || ""
    this.accountingProduct = new AccountingProduct(data.accountingProduct)
  }
  static async getDailyBillingSettingsByAreas(payload) {
    const { data } = await DailyBillingSettingAPI.getDailyBillingSettingsByAreas(payload);
    return data.result.map((item) => new DailyBillingSetting(item));
  }
  static async getDailyBillingSettingsByIncludeArea(payload) {
    const { data } = await DailyBillingSettingAPI.getDailyBillingSettingsByIncludeArea(payload);
    data.result.map((item) => new DailyBillingSetting(item));
    return data.result;
  }
  static async getDailyBillingSettingsByMeters(payload) {
    const { data } = await DailyBillingSettingAPI.getDailyBillingSettingsByMeters(payload);

    return data.result.map((item) => new DailyBillingSetting(item));
  }
  static async getDailyBillingSettings(payload) {
    const { data } = await DailyBillingSettingAPI.getDailyBillingSettings(payload);
    return data.result.map(item => (item = new DailyBillingSetting(item)));
  }
  static async createDailyBillingSetting(payload) {
    const { data } = await DailyBillingSettingAPI.createDailyBillingSetting(payload);
    let billingSetting = new DailyBillingSetting(data.result);
    return billingSetting
  }
  static async removeDailyBillingSetting(payload) {
    const { data } = await DailyBillingSettingAPI.removeDailyBillingSetting(payload);
    let billingSetting = new DailyBillingSetting(data.result);
    return billingSetting
  }
  static async removeDailyBillingSetting(payload) {
    const { data } = await DailyBillingSettingAPI.removeDailyBillingSetting(payload);
    let billingSetting = new DailyBillingSetting(data.result);
    return billingSetting
  }
  static async updateDailyBillingSetting(payload) {
    const { data } = await DailyBillingSettingAPI.updateDailyBillingSetting(payload);
    let billingSetting = new DailyBillingSetting(data.result);
    return billingSetting
  }
  static async getDailyBillingSettingsByIds(ids) {
    const { data } = await DailyBillingSettingAPI.getDailyBillingSettingsByIds(ids);
    return data.result.map(item => (item = new DailyBillingSetting(item)));
  }
}
